module.exports = __webpack_public_path__ + "static/media/icon-conversations-small.b825e8cf.svg";